import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { BenefitWizardType } from "src/app/constants/wizard-panels";

import { CoreBenefit, CoreBenefitCounter, CoreBenefitMultiple, CoreBenefitPayload, CoreBenefitResponse } from "src/app/models/core-benefit";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";

@Component({
    selector: 'mwp-benefit-enrollment-wizard-core-benefit',
    templateUrl: './core-benefit.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CoreBenefitComponent implements OnInit {
    @Input() public coreBenefitResponse: CoreBenefitResponse;
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();
    
    public displayAddMessage: boolean;
    public uniqueIds: string[] = new Array<string>();
    public requiredUniqueIds: string[] = new Array<string>();
    public categoryCounter: CoreBenefitCounter[] = new Array <CoreBenefitCounter>();
    public enableConfirmButton: boolean;

    constructor(
        private enrollmentManagerService: EnrollmentManagerService,
    ){
    }

    ngOnInit(){
        this.displayAddMessage = this.enrollmentManagerService.benefitWizardControlPanel.wizardType == BenefitWizardType.Add;
        let l_Enable: boolean = true;

        // Due to the complexitiy of multiple arrays just to retieve one id, need to do this one manually
        this.coreBenefitResponse.benefitCategories.forEach((bc: CoreBenefitMultiple) => {
            let l_CategoryEnable: boolean;
            const l_CategoryCounter = new CoreBenefitCounter();
            l_CategoryCounter.categoryID  = bc.categoryID;

            bc.items.forEach((i: CoreBenefit) => {
                if (i.isRequired) {
                    this.requiredUniqueIds.push(i.uniqueID);
                    l_CategoryCounter.count++;
                    l_CategoryEnable = true;
                } else if(i.isSelected) {
                    this.uniqueIds.push(i.uniqueID);
                    l_CategoryCounter.count++;
                    l_CategoryEnable = true;
                }
            });

            this.categoryCounter.push(l_CategoryCounter);
            if (l_Enable)
                l_Enable = l_CategoryEnable;
        });

        this.enableConfirmButton = l_Enable;
    }

    public selectedCore(event: MatCheckboxChange, uniqueID: string, categoryID: number): void {
        if (event.checked) {
            this.uniqueIds.push(uniqueID);
        } else {
            this.uniqueIds = this.uniqueIds.filter(ui => ui !== uniqueID);
        }

        let l_Enable: boolean = true;
        this.categoryCounter.forEach((cc: CoreBenefitCounter) => {
            if (cc.categoryID == categoryID)
                event.checked ? cc.count++ : cc.count--;

            if(l_Enable)
                l_Enable = cc.count > 0;
        });

        this.enableConfirmButton = l_Enable;
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public submitCoreComplete(): void {
        let l_Payload = new CoreBenefitPayload();
        l_Payload.uniqueIDs = this.requiredUniqueIds.concat(this.uniqueIds);

        this.emitComplete.emit(l_Payload);
    }
}
